document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/products/')) return;

  const viewedProducts = JSON.parse(
    sessionStorage.getItem('viewed_products') || '[]'
  );

  const productHandle = window.location.pathname.split('/products/')[1];

  if (!viewedProducts.includes(productHandle)) {
    viewedProducts.push(productHandle);

    sessionStorage.setItem(
      'viewed_products',
      JSON.stringify(viewedProducts)
    );

    if (viewedProducts.length >= 2) {
      document.dispatchEvent(
        new CustomEvent('newsletter:show')
      );
    }
  }
});